import http from "../http/http-config";
import CustomSendMailResponse from "../models/customSendMailResponse"

export default new class MailService {
    sendMail(model: string): Promise<CustomSendMailResponse> {
        return http.post<CustomSendMailResponse>("Mail", model).then(response => response.data);
    }
}